import {Injectable} from '@angular/core';
import {QuestionBase} from '../models/question-base';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Injectable()
export class QuestionControlService {
  constructor() { }

  /**@author Lupita Llamas
   * A service for transforming the questions to a FormGroup
   * and specify default values and validation rules
   * @param {QuestionBase<any>[]} questions
   * @returns {FormGroup}
   */
  toFormGroup(questions: QuestionBase<any>[] ) {
    const group: any = {};
    questions.forEach(question => {
      group[question.key] = question.required ? new FormControl(question.value || '', Validators.required)
        : new FormControl(question.value || '');
    });
    return new FormGroup(group);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/question-control.service.ts